import { useDispatch } from 'react-redux'
import { Box, Divider, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ReplayIcon from '@mui/icons-material/Replay'
import { useEffect, useState } from 'react'
import { getFormattedDate, isNotEmpty } from '../../utils/helpers'
import UseTranslation from '../../hooks/UseTranslation'

const ActiveFiltersWithKey = ({ store, actionToDispatch, title }) => {
  const [allFilters, setAllFilters] = useState([])
  const dispatch = useDispatch()
  const { t } = UseTranslation()

  const removeFilterHandler = (value) => {
    dispatch(actionToDispatch({ queries: value }))
  }
  useEffect(() => {
    const arr = []
    Object.keys(store?.activeFilters)?.forEach((key) => {
      store?.activeFilters[key]?.forEach((item) => {
        arr.push({ ...item, type: key })
      })
    })

    setAllFilters(arr)
  }, [store?.activeFilters])

  const isFilterdArraysNotEmpty = Object.values(store?.activeFilters)
    .some((singleFilter) => singleFilter?.length)
  return (
    <Box sx={styles.activeFilterContainer}>
      {title && <Typography variant="h6" sx={styles.title}>{title}</Typography>}
      <Box sx={styles.filters}>
        {allFilters?.map((singleFilter) => (

          <Box
            key={singleFilter.id + singleFilter.type}
            sx={styles.singleFilter}
            onClick={() => removeFilterHandler(singleFilter)}
          >
            { singleFilter.type === 'date'
              ? ` Period From ${getFormattedDate(singleFilter.startDate)} to ${getFormattedDate(singleFilter.endDate)}`
              : `${singleFilter.type}: ${singleFilter.name}`
          }
            <CloseIcon />
          </Box>

        ))}
      </Box>
      {title && (
      <Divider sx={styles.divider} />
      )}
      {isNotEmpty(store.activeFilters) && isFilterdArraysNotEmpty && (
        <Box sx={styles.clearBtnContainer}>
          <Box sx={styles.clearAllBtn} onClick={() => removeFilterHandler('clear')}>
            <ReplayIcon />
            {t?.['Clear Filters']}
          </Box>
        </Box>
      )}
    </Box>
  )
}
const styles = {
  activeFilterContainer: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: { xs: 'flex-start', sm: 'space-between' },
    marginBottom: { xs: '0px', sm: '26px' },
    flexWrap: { xs: 'wrap', sm: 'nowrap' },
    marginTop: { xs: '5px', sm: '25px' },
    overflowX: { xs: 'unset', sm: 'scroll' },
    scrollbarWidth: 'none',
    flexDirection: { xs: 'column', sm: 'row' },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&-ms-overflow-style:': {
      display: 'none',
    },
  },
  filters: {
    display: 'flex',
    flexWrap: { xs: 'wrap', sm: 'unset' },
    gap: { xs: '5px', sm: '0px' },
  },
  singleFilter: {
    display: 'flex',
    alignItems: 'center',
    marginRight: { xs: 0, sm: '20px' },
    backgroundColor: 'background.default',
    color: 'primary.main',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    padding: '5px 10px',
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: '12px',
    fontFamily: 'Avenir',
    width: 'max-content',
    '& svg': {
      fontSize: '14px',
      marginBottom: '-4px',
      marginLeft: '10px',
    },
  },
  clearAllBtn: {
    display: { xs: 'none', sm: 'flex' },
    alignItems: 'center',
    cursor: 'pointer',
    color: 'text.disabled',
    fontSize: { xs: '14px', sm: '16px' },
    fontFamily: 'Avenir',
    textTransform: 'capitalize',
    width: 'max-content',
    '& svg': {
      fontSize: '20px',
      marginLeft: '10px',
    },
  },
  title: {
    padding: { xs: '10px 0 10px', sm: '0px' },
    textTransform: 'capitalize',
    fontFamily: 'Avenir-bold',
    fontSize: { xs: '16px', sm: '18px' },
  },
  divider: {
    color: '#dddddd',
    width: '100%',
    marginTop: '10px',
  },
}
export default ActiveFiltersWithKey
